<div class="container with-border">
  @if (openedCitations().length >= 3) {
    <umss-citations-alert
      [openedCitations]="openedCitations()"
      [showRedirectButton]="false"
    />
  }

  <div class="header">
    <div class="header-title">
      @if (cardIconTitle(); as cardIconTitle) {
        <umss-icon [name]="cardIconTitle" size="20px" />
      }
      <h4>{{ cardTitle() }}</h4>
    </div>

    @if (showNewButton()) {
      <umss-button
        label="New"
        variant="Secondary"
        size="Small"
        leftIconName="phosphorPlusBold"
        iconSize="16px"
        (click)="openNewCitationDialog()"
      />
    }
  </div>

  <div class="citations-list">
    @if (isLoading()) {
      <div class="skeleton-card animate-pulse"></div>
      <div class="skeleton-card animate-pulse"></div>
      <div class="skeleton-card animate-pulse"></div>
    } @else if (citations().length === 0) {
      <umss-empty-state
        iconName="phosphorCheckCircleBold"
        title="No citations found"
        [showButton]="false"
      />
    } @else {
      @for (citation of citations(); track citation.id) {
        <umss-list-item
          [title]="citation.title"
          [subtitle]="citation.createdAt | date: 'MM/dd/yyyy'"
          actionLabel="Details"
          actionVariant="Outline"
          actionSize="Regular"
          (actionClicked)="onCitationDetailsActionClicked(citation)"
        >
          <umss-citation-status-badge beforeTitle [status]="citation.status" />
        </umss-list-item>
      }

      @if (showPagination()) {
        <umss-pagination
          [currentPage]="currentPage()"
          [totalPages]="totalPages()"
          (pageChange)="onPageChange($event)"
        />
      }
    }
  </div>
</div>

@if (isNewCitationDialogOpen()) {
  <umss-dialog
    [open]="isNewCitationDialogOpen()"
    size="Medium"
    type="Modal"
    position="Center"
    [backdrop]="true"
    [backdropClosable]="true"
    (onClose)="closeNewCitationDialog()"
  >
    <umss-new-citation-dialog
      [contractorId]="contractorId()"
      [facilityId]="facilityId()"
      (onClose)="closeNewCitationDialog()"
      (onSaved)="onNewCitationSaved()"
    />
  </umss-dialog>
}

@if (isDetailsDialogOpen()) {
  <umss-dialog
    [open]="isDetailsDialogOpen()"
    size="Medium"
    type="Modal"
    position="Center"
    [backdrop]="true"
    [backdropClosable]="true"
    (onClose)="closeDetailsDialog()"
  >
    @if (selectedCitationId() && dialogMode()) {
      <umss-contractor-citation-details-dialog
        [mode]="dialogMode()"
        [allowResolve]="allowResolve()"
        [citationId]="selectedCitationId()!"
        (closeDialog)="closeDetailsDialog()"
        (saved)="onCitationDetailsSaved()"
        (resolved)="onCitationResolved()"
      />
    }
  </umss-dialog>
}
